import _regeneratorRuntime from "@babel/runtime/regenerator";
import { put, call } from 'redux-saga/effects';
import { sendCommandFailure, sendCommandSuccess } from './actions';

var sendCommandSaga = /*#__PURE__*/_regeneratorRuntime.mark(function sendCommandSaga(args, action) {
  var client, command, result;
  return _regeneratorRuntime.wrap(function sendCommandSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          client = args.client;
          command = action.command;
          _context.prev = 2;
          _context.next = 5;
          return call([client, client.command], command);

        case 5:
          result = _context.sent;
          _context.next = 8;
          return put(sendCommandSuccess(command, result));

        case 8:
          _context.next = 14;
          break;

        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](2);
          _context.next = 14;
          return put(sendCommandFailure(command, _context.t0));

        case 14:
        case "end":
          return _context.stop();
      }
    }
  }, sendCommandSaga, null, [[2, 10]]);
});

export default sendCommandSaga;
//# sourceMappingURL=send-command-saga.js.map